export default __webpack_public_path__ + "static/media/1042.23bb6c71.png";